import ReactGA from 'react-ga4';

// GA4 events, named in snake_case so they line up with GA's recommended events (sign_up, login).
// Mark sign_up and analysis_complete as key events in GA (Admin → Events) to fill the leads reports.
//
// The funnel: sign_up → email_verified → project_created → clip_uploaded → analysis_complete.
// clip_uploaded fires when an analysis starts, analysis_complete or analysis_failed when it settles.

/** Send one event; analytics never gets in the way of the app */
export const track = (name, params = {}) => {
  try {
    ReactGA.event(name, params);
  } catch {
    // An ad blocker or a missing tag shouldn't break a sign-up or an upload
  }
};

/**
 * Track an analysis from upload to result. `params` describes the clip ({ kind, category, version });
 * returns `promise` unchanged.
 */
export const trackAnalysis = (promise, params) => {
  track('clip_uploaded', params);
  const startedAt = Date.now();
  promise.then(
    () => track('analysis_complete', { ...params, seconds: Math.round((Date.now() - startedAt) / 1000) }),
    () => track('analysis_failed', params)
  );
  return promise;
};
